import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';
import { connect } from 'react-redux';

import ImageUpload from '../imageUpload/ImageUpload';
import { closeModal } from '../../actions/modalAction';

const actions = { closeModal };

class ShowImageModal extends Component {
  render() {
    return (
      <Modal 
      className='min-max-width'
      //size="tiny" 
      open={true} 
      onClose={this.props.closeModal}
      closeOnEscape={false}
      closeOnDimmerClick={false}
      >
       
        <Modal.Content>
        <ImageUpload 
            id = {this.props.id}
            imgRoute = {this.props.imgRoute}
            apiRoute = {this.props.apiRoute}
            handleRefresh={this.props.handleRefresh}
            />
        </Modal.Content>
      </Modal>
    );
  }
}

export default connect(
  null,
  actions
)(ShowImageModal);
